module.exports = __webpack_public_path__ + "static/media/delete-red.8c73f6b7.svg";